// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__2ze6D","body":"Modal_body__u3SMM","close":"Modal_close__2AzFo"};